export enum Operators {
    MORE_THAN= "more_than",
    EQUALS= "equals",
    LESS_THAN = "less_than"
 }
 